import React from 'react'

const Contactpage = () => {
  return (
    <div>Contactpage</div>
  )
}

export default Contactpage;